import client from './client';

export default (function MembershipConcernService() {
  let service;

  if (!service) {
    service = client.service('membershipConcerns');
  }

  return service;
}());
